module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/48.e39f96e4.png";